import styles from './ScenarioGenerator.module.css';

/**
 * 生成プロバイダ切替用のセグメンテッドコントロール。
 * ナレーション (ElevenLabs / Gemini) と BGM (ElevenLabs / Lyria) で共用する。
 * フィルタチップとは役割が違うため、専用の控えめなセグメント見た目にする。
 */
export function ProviderSegmentedControl<T extends string>({
  options,
  value,
  onChange,
  disabled,
}: {
  options: ReadonlyArray<{ value: T; label: string; tooltip?: string }>;
  value: T;
  onChange: (value: T) => void;
  disabled?: boolean;
}) {
  return (
    <div className={styles.providerSegmented} role="radiogroup" aria-label="生成プロバイダ">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={value === opt.value}
          className={`${styles.providerSegmentedBtn} ${value === opt.value ? styles.providerSegmentedBtnActive : ''}`}
          onClick={() => { if (value !== opt.value) onChange(opt.value); }}
          disabled={disabled}
          title={opt.tooltip}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
